import request from '@/plugin/axios'

/**
 * 根据账套id获取当前期
 * @param {*} accountId
 */
export function getCurrentAccountInfo(accountId) {
  return request({
    url: '/finance/account/' + accountId,
    method: 'get'
  })
}

/**
 * 获取分页
 * @param {Object} data
 * @returns {AxiosPromise}
 */
export function getAccountPage(data) {
  return request({
    url: '/finance/account/page',
    method: 'get',
    params: data
  })
}

/**
 * 获取列表
 * @param {Object} data
 * @returns {AxiosPromise}
 */
export function getAccountList() {
  return request({
    url: '/finance/account/list',
    method: 'get'
  })
}

/**
 * 添加
 * @param {Object} data
 * @returns {AxiosPromise}
 */
export function addAccount(data) {
  return request({
    timeout: 30000,
    url: '/finance/account',
    method: 'post',
    data: JSON.stringify(data)
  })
}

/**
 * 编辑
 * @param {Object} data
 * @returns {AxiosPromise}
 */
export function editAccount(data) {
  return request({
    url: '/finance/account',
    method: 'put',
    data
  })
}

/**
 * 批量删除
 * @param {Array} ids
 * @returns {AxiosPromise}
 */
export function delAccountList(ids) {
  return request({
    url: '/finance/account',
    method: 'delete',
    data: JSON.stringify(ids)
  })
}

export function pageList(data) {
  return request({
    url: '/finance/account/pageList',
    method: 'get',
    params: data
  })
}

export function authorizationAccount(data) {
  return request({
    url: '/finance/account/authorizationAccount',
    method: 'post',
    data: data
  })
}

export function authorizationUser(data) {
  return request({
    url: '/finance/account/authorizationUser',
    method: 'post',
    data: data
  })
}

export function listHasChecked(data) {
  return request({
    url: '/finance/account/listHasChecked/' + data,
    method: 'get'
  })
}

export function importAccount(data) {
  return request({
    url: '/finance/account/importAccount',
    method: 'get'
  })
}



export function disable(data) {
  return request({
    url: '/finance/account/disable',
    method: 'get',
    params: data
  })
}



export function enable(data) {
  return request({
    url: '/finance/account/enable',
    method: 'get',
    params: data
  })
}



export function getBindableAccountList(data) {
  return request({
    url: '/finance/account/getBindableAccountList',
    method: 'get'
  })
}

